"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * cancel a DOM event
 * @param event the DOM event
 */
function stop(event) {
    if (event.preventDefault) {
        event.preventDefault();
    }
    if (event.stopPropagation) {
        event.stopPropagation();
    }
    else {
        event.cancelBubble = true;
    }
}
exports.stop = stop;
function addStyles(css, id) {
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (id) {
        style.id = id + "-stylesheet";
    }
    if ("styleSheet" in style) {
        style.styleSheet.cssText = css;
    }
    else {
        style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
}
exports.addStyles = addStyles;
exports.getType = function (topic) { return Object.prototype.toString.call(topic).slice(8, -1); };
exports.isArray = function (topic) { return exports.getType(topic) === "Array"; };
exports.isNull = function (topic) { return exports.getType(topic) === "Null"; };
exports.isUndefined = function (topic) { return exports.getType(topic) === "Undefined"; };
exports.isPromise = function (topic) { return exports.getType(topic) === "Promise"; };
exports.unbind = Function.prototype.bind.bind(Function.prototype.call);
exports.trim = exports.unbind(String.prototype.trim);
exports.slice = exports.unbind(Array.prototype.slice);
